import { isVideo, photoUrl, thumbUrl } from "../../lib/photos";

/** Miniatuur van een foto of video bij een bevinding. Video's tonen het eerste beeld met een afspeelteken. */
export function MediaThumb({ fileId, mime, alt }: { fileId: string; mime?: string | null; alt: string }) {
  if (!isVideo(fileId, mime)) return <img src={thumbUrl(fileId)} alt={alt} loading="lazy" />;
  return (
    <span className="phvideo">
      {/* #t=0.1: laat browsers (ook iOS Safari) het eerste beeld als voorbeeld tonen. */}
      <video src={`${photoUrl(fileId)}#t=0.1`} preload="metadata" muted playsInline aria-label={alt} />
      <span className="play" aria-hidden="true">
        ▶
      </span>
    </span>
  );
}
